import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 10,
};

const orderOverweightSlice = createSlice({
  name: 'orderOverweightUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const { setPage, setItemsPerPage, resetFilters } = orderOverweightSlice.actions;
const allOrderOverweightReducer = orderOverweightSlice.reducer;
export default allOrderOverweightReducer;
